var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0B7385A2-426D-40BB-A407-C80389A3496F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-132.000000, -480.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(126.000000, 472.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(7.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4.5 L26,4.5",
    id: "Path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,16.5 L21.9205845,16.5",
    id: "Path-17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12",
    points: "0 3.30973684 2.47657694 6 8 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,20 L7,14",
    id: "Path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,20 L7,14",
    id: "Path-12",
    transform: "translate(4.000000, 17.000000) scale(-1, 1) translate(-4.000000, -17.000000) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStatus);
export default __webpack_public_path__ + "static/media/ico_status.f6172285a44641f6702e0c7768db0e2e.svg";
export { ForwardRef as ReactComponent };